export default __webpack_public_path__ + "static/retirement-planning-8-7f58e6d8b5104efe0678abc06633bc64.png";